import React, { useEffect, useState } from 'react';

import { Autocomplete } from '@mui/material';

import axios from '../modules/axios';
import StrongTextField from './StrongTextField';

export default ({
  resource,
  attribute,
  attributeId,
  associations,
  filters,
  value,
  renderInput,
  optionLabel,
  renderOption,
  onChange,
  onInputChange,
  debounce = 500,
  sort,
  disabled,
  /* Use (or not) the 'attribute' provided as a filter with the inputValue
   * If 'false', it behave as an API Select only using information provided in props
   */
  fetchRemote = true,
  ...other
}) => {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!(resource && attributeId && value)) {
      setLoaded(true);

      return;
    }

    const params = [`${attributeId}=${value}`];

    for (let attr in filters) {
      params.push(`${attr}=${filters[attr]}`);
    }

    if (associations) params.push(`_associations=${associations}`);
    if (sort) params.push(`_sort=${sort}`);

    axios.get(`${resource}?${params.join('&')}`).then(res => {
      setOptions(res.data);
      setLoaded(true);
    });
  }, [associations, attributeId, filters, resource, sort, value]);

  useEffect(() => {
    const timer = setTimeout(() => {
      const filtersUrl = [];
      if (inputValue && fetchRemote) filtersUrl.push(`${attribute}=${encodeURIComponent(`%${inputValue}%`)}`);
      for (let attr in filters) {
        filtersUrl.push(`${attr}=${filters[attr]}`);
      }

      if (associations) filtersUrl.push(`_associations=${associations}`);
      if (sort) filtersUrl.push(`_sort=${sort}`);
      filtersUrl.push(`_limit=200`);

      axios.get(`${resource}?${filtersUrl.join('&')}`).then(res => setOptions(res.data));
    }, debounce);

    return () => clearTimeout(timer);
  }, [inputValue, attribute, resource, filters, associations, debounce, sort, fetchRemote]);

  if (loaded) {
    return (
      <Autocomplete
        autoComplete
        getOptionLabel={optionLabel ? optionLabel : option => option[attribute]}
        options={options}
        freeSolo
        renderInput={params => renderInput || <StrongTextField {...params} {...other} variant='outlined' fullWidth />}
        onChange={onChange}
        defaultValue={options.length > 0 ? options[0] : null}
        onInputChange={(event, newInputValue) => {
          onInputChange && onInputChange(event, newInputValue);
          setInputValue(newInputValue);
        }}
        renderOption={renderOption}
        disabled={disabled}
      />
    );
  }

  return <></>;
};
